import { ContextType } from "./context-type.enum";
import { NextStepDeciderConfig } from "./next-step-decider-config.model";
import { StepConfig } from "./step-config.model";
import { StepType } from "./step-type.enum";

export class DemographicsStepConfig extends StepConfig {

  showOptionToNotProvideDemographicsInfo: boolean = true;

  constructor(id: string, name: string | undefined, path: string, groupId: number | undefined, nextStepDeciderConfig: NextStepDeciderConfig | undefined) {
    super(id, name, path, groupId, ContextType.None);
    this.stepType = StepType.DemographicsStep;
    this.nextStepDeciderConfig = nextStepDeciderConfig;
    this.showOptionToNotProvideDemographicsInfo = true;
  }
}
